export default [
    {
        path: '/pages/common/agreement/cloud-agreement',
        name: 'CloudAgreement',
        component: () => import('@/pages/common/agreement/cloud-agreement.vue'),
        meta: {
            title: '协议',
            keepAlive: false
        }
    }
]